/**
 * PRAT-111 — lembranças do aparelho para os convites de avaliação
 * (localStorage, sempre com try/catch: no modo privado só não lembra).
 */
import { trackStoreEvent } from '@/modules/analytics/store-events/store-events';

import type { RatingSource } from '../types/rate-order';

const autoOpenedKey = (orderId: string) => `pratigo:avaliacao-aberta:${orderId}`;
const bannerDismissedKey = (orderId: string) => `pratigo:avaliacao-faixa-dispensada:${orderId}`;
const promptTrackedKey = (orderId: string, channel: string) =>
  `pratigo:avaliacao-convite:${orderId}:${channel}`;
export const ORDER_PUSH_PROMPT_KEY = 'pratigo:avisos-do-pedido-convite';

function read(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* modo privado: só não lembra */
  }
}

/** A avaliação de 1 toque abre sozinha uma vez por pedido. */
export function wasRatingAutoOpened(orderId: string): boolean {
  return read(autoOpenedKey(orderId)) === '1';
}

export function markRatingAutoOpened(orderId: string): void {
  write(autoOpenedKey(orderId), '1');
}

/** "X" na faixa: aquele pedido não volta a aparecer. */
export function isRatingBannerDismissed(orderId: string): boolean {
  return read(bannerDismissedKey(orderId)) === '1';
}

export function dismissRatingBanner(orderId: string): void {
  write(bannerDismissedKey(orderId), '1');
}

/**
 * `rating_prompt_shown` uma vez por pedido e canal neste aparelho — é a base da
 * conversão por canal no Desempenho da Loja.
 */
export function trackRatingPromptShown(
  orderId: string,
  channel: RatingSource,
  slug?: string | null
): void {
  const key = promptTrackedKey(orderId, channel);
  if (read(key) === '1') return;
  write(key, '1');
  trackStoreEvent('rating_prompt_shown', {
    slug: slug || undefined,
    orderId,
    props: { channel },
  });
}

/** Convite "avisos do pedido" aparece uma vez por aparelho. */
export function wasOrderPushPromptShown(): boolean {
  return read(ORDER_PUSH_PROMPT_KEY) !== null;
}

export function markOrderPushPromptShown(answer: 'aceito' | 'dispensado'): void {
  write(ORDER_PUSH_PROMPT_KEY, answer);
}
